<template>
  <Hero
    :image="getStrapiImageLocation(data?.hero?.image) || ''"
    image-provider="strapi"
    extra-content-classes="vcenter grid--two"
    :vertical-center="true"
    small
  >
    <template #left>
      <h2 class="heading--med text--white" v-html="addBreakToBold(data?.hero?.heading || '')"></h2>
    </template>
  </Hero>
  <main class="main">
    <div class="block block--y maxw--inner" id="verhalen">
      <div class="grid--two grid--small-gap grid--bigger-row flex-start">
        <StoryItem
          v-for="story in stories"
          :key="story.id"
          :data="story"
        />
      </div>
    </div>
  </main>
</template>

<script lang="ts" setup>
import type { Strapi5RequestParams } from '@nuxtjs/strapi';
import type StoryPage from '~/typings/strapi/pages/storyPage';

const route = useRoute();
const { find, findOne } = useStrapi();

const { data } = await useAsyncData(
  'storyOverviewPage',
  async () => {
    const params = await useDraft({
      populate: [
        'hero', 'hero.image', 'seo', 'seo.metaImage'
      ]
    });

    return await findOne('story-overview-page', params);
  },
  {
    transform: flattenObject
  }
);

const { data: stories } = await useAsyncData(
  'stories',
  () => {
    const storyFetchConfiguration = {
      sort: 'publishedAt:desc',
      populate: ['thumbnail', 'tags'],
    } as Strapi5RequestParams;

    if (route.query?.tag) {
      storyFetchConfiguration.filters = {
        tags: {
          name: {
            $eqi: route.query.tag
          } 
        }
      }
    }

    return find<StoryPage>('story-pages', storyFetchConfiguration);
  },
  {
    // TODO: see if this needs to be applied
    // watch: route.params,
    transform: flattenCollection
  }
);

useHead({
  title: 'Ervaringsverhalen',
});

useSeoMeta({
  description: data.value?.seo?.metaDescription,
  ogTitle: data.value?.seo?.metaTitle,
  ogDescription: data.value?.seo?.metaDescription,
  ogImage: getStrapiImageLocation(data.value?.seo?.metaImage, true),
  ogUrl: 'https://werkenbijvaneerd.nl/privacybeleid/',
  twitterTitle: data.value?.seo?.metaTitle,
  twitterDescription: data.value?.seo?.metaDescription,
  twitterImage: getStrapiImageLocation(data.value?.seo?.metaImage, true),
  twitterCard: 'summary_large_image',
})
</script>
